<template>
  <v-card outlined>
    <v-container fluid>
      <v-row align="center" dense>
        <v-col v-for="item in items" v-bind:key="item.name" class="d-flex align-center justify-center" style="cursor: pointer;" @click="goToRoute(item)">
          <v-icon v-if="itemSelected === item.name" :style="`color: #${$store.state.clubMember.club.primaryColor}`" small>{{ item.icon }}</v-icon>
          <v-icon v-else small>{{ item.icon }}</v-icon>
          <h3 v-if="itemSelected === item.name" :style="`color: #${$store.state.clubMember.club.primaryColor}`" class="ml-2">{{ item.name }}</h3>
          <h3 v-else class="ml-2">{{ item.name }}</h3>
          <h4 class="badge text-center ml-2 mb-0"
              v-if="$store.state.clubMember.rol !== 'MEMBER' && item.route === '/club/members' && pendingMembers > 0">
            {{ (pendingMembers > 9)? '+9' : pendingMembers }}
          </h4>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "ClubMenu",
  data() {
    return {
      pendingMembers: 0,
      itemSelected: 'Dashboard',
      items: []
    };
  },
  watch: {
    '$store.state.clubMembers': function () {
      this.seePendingRequests();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.items = [
        {name: this.$t('dashboard'), route: '/club', icon: 'fa-home', admin: false},
        {name: this.$t('events'), route: '/club/events', icon: 'fa-calendar-alt', admin: false},
        {name: this.$t('chats'), route: '/club/chats', icon: 'fa-comments', admin: false},
        {name: this.$t('rooms'), route: '/club/rooms', icon: 'fa-video', admin: false},
        {name: this.$t('tournaments'), route: '/club/tournaments', icon: 'fa-trophy', admin: false},
        {name: this.$t('members'), route: '/club/members', icon: 'fa-users', admin: false},
      ];
      if(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN') {
        this.items.push({name: this.$t('performance'), route: '/club/performance', icon: 'fa-chart-bar', admin: true});
        this.items.push({name: this.$t('channels'), route: '/club/channels', icon: 'fa-layer-group', admin: true});
      }
    },
    goToRoute(item) {
      this.itemSelected = item.name;
      this.$router.push(item.route);
    },
    seePendingRequests() {
      this.pendingMembers = this.$store.state.clubMembers.filter((member) => member.rol === 'PENDING').length;
    },
  },
}
</script>

<style scoped>
 .badge {
   background-color: #EF5350 !important;
   font-size: 12px !important;
   color: #FFFFFF;
   border-radius: 100%;
   width: 20px;
   height: 20px;
   padding-top: 1.5%;
 }

</style>


<i18n>
{
  "en":{
    "dashboard": "Dashboard",
    "events": "Events",
    "chats": "Chats",
    "rooms": "Rooms",
    "tournaments": "Tournaments",
    "members": "Members",
    "channels": "Channels",
    "performance": "Performance"
  },
  "es":{
    "dashboard": "Dashboard",
    "events": "Eventos",
    "chats": "Chats",
    "rooms": "Salas",
    "tournaments": "Torneos",
    "members": "Miembros",
    "channels": "Canales",
    "performance": "Rendimiento"
  }
}
</i18n>
